export default __webpack_public_path__ + "774e34a0da36d46e1cb5eddbb113541c.png";